import React from 'react';
import ComplianceListGrid from '../../components/vessel-info/compliance-list-grid/ComplianceListGrid';

export default function ComplianceCheckListing() {
  return <ComplianceListGrid />;
}
